<template>
  <div ref="mainDiv" >
    <top-header v-if="$store.getters.getUserType != 1"></top-header>
    <div class="title-container">
      <p style="padding-bottom: 20px;font-size: 30px">{{this.$store.getters.getUserType != 1 ? '机构云盘' : teaCloudDiskName}}</p>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item in this.breadcrumbList">
          <a @click="breadcrumbItemClick(item)">{{item.fileInfo.name}}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-row style="padding-top: 20px" v-if="!isReadOnly">
        <el-button :class="{'tea-cloud-disk-btn' : $store.getters.getUserType === 1}"
          type="primary"
          size="small"
          icon="el-icon-folder-checked"
          @click="handleSelectAll">全选</el-button>
        <el-upload style="display:inline;padding-right: 10px;padding-left: 10px"
                   accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.ppt,.pptx,.flv,.mp4,.mp3,.avi,.mov,.mkv,.m4a"
                   name="qianxue"
                   action=""
                   :show-file-list="false"
                   :on-success="uploadFileSuccess"
                   :before-upload="beforeUploadFile">
          <el-button :class="{'tea-cloud-disk-btn' : $store.getters.getUserType === 1}"
            type="primary"
            size="small"
            icon="el-icon-upload">上传</el-button>
        </el-upload>
        <el-button :class="{'tea-cloud-disk-btn' : $store.getters.getUserType === 1}"
          type="primary"
          size="small"
          icon="el-icon-folder-add"
          @click="handleAddFolder">新建</el-button>
        <el-button :class="{'tea-cloud-disk-btn' : $store.getters.getUserType === 1}"
          type="primary"
          size="small"
          icon="el-icon-delete"
          @click="handleDeleteFile">删除</el-button>
        <el-button :class="{'tea-cloud-disk-btn' : $store.getters.getUserType === 1}"
          type="primary"
          size="small"
          icon="el-icon-rank"
          @click="handleMoveFolder">移动</el-button>

        <el-button style="float: right;margin-right: 30px;margin-top: 5px" :class="{'tea-cloud-disk-btn' : $store.getters.getUserType === 1}"
                   type="primary"
                   size="small"
                   icon="el-icon-search"
                   @click="searchBtnClick">搜索</el-button>
        <el-input style="width: 300px;float: right;padding-right: 10px"
                  placeholder="请输入内容"
                  prefix-icon="el-icon-search"
                  v-model="searchValue">
        </el-input>
      </el-row>
    </div>
    <div ref="fileListDiv" class="file-list">
      <div v-for="item in this.curTree.children">
        <cloud-disk-item-component v-bind:file-info="item.fileInfo"
                                   @delBtnClick="delBtnClick(item)"
                                   @itemClick="itemClick(item)"
                                   @checkboxChanged="itemChecked(item)"
                                   @fielNameChangedByAdd="itemFileNameChangedByAdd(item)"
                                   @fielNameChanged="itemFileNameChanged(item)"></cloud-disk-item-component>
      </div>
    </div>
    <el-dialog title="移动到" :visible.sync="dialogMoveFile" v-if="dialogMoveFile">
      <cloud-disk-folder-tree ref="moveToFolderTree"
                              @okBtnClick="moveFolderOkBtnClick()"
                              v-bind:disableList="getSelectedTree()"></cloud-disk-folder-tree>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="dialogPrrview">
      <cloud-disk-image-preview ref="imagePreview"></cloud-disk-image-preview>
    </el-dialog>
    <el-button v-show="showScrollTopBtn" ref="scrollTopBtn" icon="el-icon-arrow-up" @click="scrollTopBtnClick" circle style="position:fixed;right:20px;bottom:20px;"></el-button>
  </div>
</template>

<script>
  import TopHeader from '../../components/TopHeader'
  import CloudDiskItemComponent from '../../components/cloudDisk/CloudDiskItemComponent'
  import CloudDiskFolderTree from '../../components/cloudDisk/CloudDiskFolderTree'
  import BMF from 'browser-md5-file'
  import CloudDiskImagePreview from '../../components/cloudDisk/CloudDiskImagePreview'
  import { Base64 } from 'js-base64'
  export default {
  name: 'CloudDisk',
  components: {CloudDiskImagePreview, CloudDiskFolderTree, CloudDiskItemComponent, TopHeader},
  data () {
    return {
      rootTree: {
        fileInfo: {
          id: 0,
          name: '全部资料',
          fileType: 0
        },
        parent: null,
        children: []
      },
      curTree: null,
      searchValue: '',
      selectAll: false,
      breadcrumbList: [],
      dialogMoveFile: false,
      file: null,
      dialogPrrview: false,
      isReadOnly: false,
      teaCloudDiskName: '老师云盘',
      showScrollTopBtn: true,
      aliUploader: null

    }
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/clouddiskop') {
          console.log('----', route.path)
          that.getCurData()
        }
      },
      deep: true
    }
  },
  mounted () {
    console.log('addEventListener--scroll')
    window.addEventListener('scroll', this.scrollToTop, true)
  },
  created () {
    this.getCurData()
  },
  methods: {
    getCurData () {
      if (this.curTree === null) {
        this.curTree = this.rootTree
        this.reloadBreadcrumbList()
      }
      let requestData = {parentid: this.curTree.fileInfo.id, dir: 0}
      this.$api.cloudDisk.getFileList(requestData).then((res) => {
        if (res.code === 0) {
          if (res.data == null || res.data === undefined) {
            let curChildren = []
            this.curTree.children = curChildren
          } else {
            let curChildren = this.formatResponseList(res.data)
            // this.curTree.children = []
            this.$set(this.curTree, 'children', curChildren)
            this.checkUploadStatus(curChildren)
            console.log('curTree', this.curTree)
          }
        }
      })
    },
    handleAddFolder () {
      this.$api.home.interCheck().then((res) => {

      })
      let newTree = {fileInfo: {name: '', fileType: 0, updateTime: '', isEdit: true}, parent: this.curTree, children: []}
      this.curTree.children.unshift(newTree)
    },
    itemFileNameChangedByAdd (item) {
      let fileModel = {parentid: this.curTree.fileInfo.id, filetype: 0, md5: '1111', name: item.fileInfo.name, url: '111'}
      this.$api.cloudDisk.addFile(fileModel).then((res) => {
        if (res.code === 0) {
          this.getCurData()
        }
      })
    },
    itemFileNameChanged (item) {
      let fileModel = {id: item.fileInfo.id, name: item.fileInfo.name}
      this.$api.cloudDisk.modifyFile(fileModel).then((res) => {
        if (res.code === 0) {
          this.getCurData()
        }
      })
    },
    itemClick (item) {
      if (item.fileInfo.fileType === 0) {
        if (item.bySearch === true) {
          this.itemClcikBySearch(item)
        } else {
          this.curTree = item
          this.reloadBreadcrumbList()
          this.getCurData()
        }
      } else {
        this.dialogPrrview = true
        if (this.$refs.imagePreview === undefined || this.$refs.imagePreview === null) {
          let that = this
          setTimeout(function () {
            // TODO 预览
            that.$refs.imagePreview.setLoadFile(item.fileInfo.url, item.fileInfo.pageNum)
          }, 100)
        } else {
          this.$refs.imagePreview.setLoadFile(item.fileInfo.url, item.fileInfo.pageNum)
        }
      }
      console.log(item.fileInfo)
    },
    itemClcikBySearch (item) {
      let requestData = {id: item.fileInfo.id}
      this.$api.cloudDisk.getFileParentList(requestData).then((res) => {
        if (res.code === 0) {
          let parentList = res.data
          let curItem = item
          if (parentList.length > 1) {
            for (let i = 1; i < parentList.length; i++) {
              let responseItem = parentList[i]
              let parent = {fileInfo: {id: responseItem.id, name: responseItem.name}}
              curItem.parent = parent
              curItem = parent
            }
          }
          curItem.parent = this.rootTree
          this.curTree = item
          this.reloadBreadcrumbList()
          this.getCurData()
        }
      })
    },
    itemChecked (item) {
      let allItemIsSelect = this.getCurTreeAllIsSelected()
      this.selectAll = allItemIsSelect
    },
    delBtnClick (item) {
      let requestData = {id: item.fileInfo.id}
      this.$api.cloudDisk.delFile(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getCurData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleSelectAll () {
      this.selectAll = !this.selectAll
      this.checkCurTreeAllSelect(this.selectAll)
    },
    uploadFileSuccess (res, file) {
      console.log('res====', res)
    },
    checkFileTypeIsDoc (extName){
      return [
        'jpg','jpeg','png','pdf','doc','docx','ppt','pptx'].
      indexOf(extName.toLowerCase()) !== -1;
    },
    beforeUploadFile (file) {
      // debugger
      // let types = ['image/jpeg', 'image/png', 'application/pdf']
      // const isImage = types.includes(file.type)
      // if (!isImage) {
      //   this.$message.error('请上传jpeg、png格式图片')
      //   return false
      // }
      let tmpIndex = file.name.lastIndexOf(".")
      let extName = file.name.substr(tmpIndex+1)
      let isDoc = this.checkFileTypeIsDoc(extName)

      //测试代码


      console.log('fileName------', file.name)
      // 验证大小
      if (isDoc) {
        if (file.size / 1024 / 1024 > 30) {
          this.$message.error('最大上传30M')
          return false
        }
      } else {
        if (file.size / 1024 / 1024 > 200) {
          this.$message.error('最大上传200M')
          return false
        }
      }

      // 验证MD5
      let bmf = new BMF()
      bmf.md5(file, (error, md5) => {
          if (error === null || error === undefined) {
            console.log('fileName:', file.name)
            console.log('md5-----', md5)
            console.log('error: ', error)

            let requestData = {name: file.name, md5: md5, parent: this.curTree.fileInfo.id}
            this.$api.cloudDisk.checkFileMd5(requestData).then((res) => {
              if (res.code === 0) {
                let exist = res.data.exist
                // 不存在，先上传文件
                if (exist === 0) {
                  if (isDoc) {
                    this.uploadCloudDiskFile(file)
                  } else {
                    this.uploadCloudMediaFile(file,md5)
                  }
                  return false
                } else {
                  // 已经存在，直接调用添加云盘接口
                  this.$message({
                    type: 'success',
                    message: '上传成功'
                  })
                  this.addFileToServer(res.data.docid, file.name, res.data.url, res.data.md5, 1)
                  return false
                }
              }
            }).catch((error) => {
              console.log('验证MD5 Error', error)
              if (isDoc) {
                this.uploadCloudDiskFile(file)
              } else {
                this.uploadCloudMediaFile(file, md5)
              }

              return false
            })
          }
        },
        progress => {

        })
    },
    uploadCloudMediaFile (file, md5) {
      if (this.aliUploader) {
        this.aliUploader.stopUpload()
      }
      this.aliUploader = this.createUploader()
      let userData = '{"Vod":{},"md5":"' + md5 +'"}'
      console.log(userData)
      this.aliUploader.addFile(file, null, null, null, userData)
      if (this.aliUploader !== null) {
        this.aliUploader.startUpload()
      }
    },
    uploadCloudMediaFileSuccess (videoId, fileName, md5) {
      console.log('uploadCloudMediaFileSuccess' + videoId)
      let requestData = {videoid: videoId}
      let that = this
      this.$api.cloudDisk.getMediaUrl(requestData).then((res) => {
        if (res.code === 0) {
          let url = res.data.url
          that.addFileToServer(videoId,fileName,url,md5,3)
        }
      })
    },
    uploadCloudDiskFile (file) {
      let uploadParam = new FormData()
      uploadParam.append('qianxue', file)
      this.$api.cloudDisk.uploadFile(uploadParam).then((res) => {
        console.log('cloudDisk', res)
        if (res.code === 0) {
          this.addFileToServer(res.data.docid, file.name, '', res.data.md5, 1)
          this.$message({
            type: 'success',
            message: '上传成功'
          })
        }
      })
    },
    addFileToServer (docid, fileName, url, md5, filetype) {
      let fileModel = {parentid: this.curTree.fileInfo.id, filetype: filetype, docid: docid, name: fileName, url: url, md5: md5}
      this.$api.cloudDisk.addFile(fileModel).then((res) => {
        if (res.code === 0) {
          this.getCurData()
        }
      })
    },
    handleDeleteFile () {
      let selectList = this.getSelectedTree()
      this.recursionDelFile(selectList)
    },
    handleMoveFolder () {
      this.dialogMoveFile = true
    },
    moveFolderOkBtnClick () {
      let selectList = this.getSelectedTree()
      this.recursionMoveFile(selectList)
    },
    searchBtnClick () {
      if (this.searchValue === undefined || this.searchValue === '') {
        this.getCurData()
        return
      }
      let requestData = {key: this.searchValue}
      this.$api.cloudDisk.getFileListBySearch(requestData).then((res) => {
        this.reloadBreadcrumbList()
        if (res.data == null || res.data === undefined) {
          let curChildren = []
          this.curTree.children = curChildren
        } else {
          let curChildren = this.formatSearchResponseList(res.data)
          this.curTree.children = []
          this.curTree.children = curChildren
        }
      })
    },
    breadcrumbItemClick (item) {
      this.curTree = item
      this.reloadBreadcrumbList()
      this.getCurData()
    },
    recursionMoveFile (moveList) {
      if (moveList !== null && moveList.length > 0) {
        let moveItem = moveList.shift()
        let newId = this.$refs.moveToFolderTree.getSelectKey()
        let requestData = {id: moveItem.fileInfo.id, newid: newId}
        console.log('移动中：', moveItem.fileInfo.name)
        console.log('剩余数量：', moveItem.length)
        this.$api.cloudDisk.moveFile(requestData).then((res) => {
          if (res.code === 0) {
            if (moveList.length > 0) {
              this.recursionMoveFile(moveList)
            } else {
              this.$message({
                type: 'success',
                message: '移动成功'
              })
              this.dialogMoveFile = false
              this.getCurData()
            }
          } else {
            this.$message.error(res.msg)
            this.getCurData()
          }
        })
      }
    },
    recursionDelFile (delList) {
      // let a = []
      if (delList !== null && delList.length > 0) {
        let delItem = delList.shift()
        let requestData = {id: delItem.fileInfo.id}
        console.log('删除中：', delItem.fileInfo.name)
        console.log('剩余数量：', delList.length)
        this.$api.cloudDisk.delFile(requestData).then((res) => {
          if (res.code === 0) {
            if (delList.length > 0) {
              this.recursionDelFile(delList)
            } else {
              this.$message({
                type: 'success',
                message: '批量删除成功'
              })
              this.getCurData()
            }
          } else {
            this.$message.error(res.msg)
            this.getCurData()
          }
        })
      }
    },
    checkCurTreeAllSelect (selected) {
      for (let i = 0; i < this.curTree.children.length; i++) {
        let item = this.curTree.children[i]
        // item.fileInfo.checked = selected
        this.$set(item.fileInfo, 'checked', selected) // 解决不刷新问题
      }
      console.log(this.curTree.children)
    },
    getSelectedTree () {
      let resList = []
      for (let i = 0; i < this.curTree.children.length; i++) {
        let item = this.curTree.children[i]
        // item.fileInfo.checked = selected
        if (item.fileInfo.checked === true) {
          resList.push(item)
        }
      }
      return resList
    },
    checkUploadStatus (childrenList) {
      console.log('-----------------------------------------------')
      let hasCheckUpload = false
      for (let i = 0; i < childrenList.length; i++) {
        let item = childrenList[i]
        let itemCreateTime = new Date(item.fileInfo.updateTime).getTime()
        if (itemCreateTime > new Date().getTime() - 60 * 60 * 1000) {
          if (item.fileType !== 0) {
            if (item.fileInfo.url === undefined || item.fileInfo.url === null || item.fileInfo.url === '') {
              hasCheckUpload = true
              let requestData = {docid: item.fileInfo.guid}
              console.log('item:',item)
              console.log('requestData:',requestData)
              this.$api.cloudDisk.getUploadStatus(requestData).then((res) => {
                console.log(res)
                if (res.code === 0) {
                  if (res.data.Status === 1) {
                    setTimeout(this.getCurData, 5000)
                    return
                  }
                }
              })
            }
          }
        }
      }
      if (hasCheckUpload) {
        setTimeout(() => {
          this.checkUploadStatus(this.curTree.children)
        }, 5000)
      }
    },
    getCurTreeAllIsSelected () {
      for (let i = 0; i < this.curTree.children.length; i++) {
        let item = this.curTree.children[i]
        if (item.fileInfo.checked === false || item.fileInfo.checked === undefined) {
          return false
        }
      }
      return true
    },
    reloadBreadcrumbList () {
      this.breadcrumbList = []
      let tmpTree = this.curTree
      this.breadcrumbList.push(tmpTree)
      while (tmpTree.parent !== null && tmpTree.parent !== undefined) {
        tmpTree = tmpTree.parent
        this.breadcrumbList.unshift(tmpTree)
      }
      console.log(this.breadcrumbList)
    },
    formatResponseList (list) {
      let resList = []
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        let resItem = {fileInfo: {id: item.id}, parent: this.curTree}
        let isFolder = item.file_type === 0
        if (isFolder) {
          resItem.fileInfo.fileType = 0
          resItem.children = []
          resItem.fileInfo.name = item.name
          resItem.fileInfo.updateTime = item.update_time
        } else {
          resItem.fileInfo.fileType = 1
          resItem.fileInfo.name = item.name
          resItem.fileInfo.updateTime = item.update_time
          resItem.fileInfo.url = item.url
          resItem.fileInfo.pageNum = item.pageNum
          resItem.fileInfo.guid = item.guid
        }
        resList.push(resItem)
      }
      console.log(resList)
      return resList
    },
    formatSearchResponseList (list) {
      let resList = []
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        let resItem = {fileInfo: {id: item.id}, parent: this.curTree, bySearch: true}
        let isFolder = item.filetype === 0
        if (isFolder) {
          resItem.fileInfo.fileType = 0
          resItem.children = []
          resItem.fileInfo.name = item.name
          resItem.fileInfo.updateTime = item.update_time
        } else {
          resItem.fileInfo.fileType = 1
          resItem.fileInfo.name = item.name
          resItem.fileInfo.updateTime = item.update_time
          resItem.fileInfo.extName = item.ext_name
          resItem.fileInfo.url = item.url
          resItem.fileInfo.pageNum = item.pageNum
          resItem.fileInfo.guid = item.guid
        }
        resList.push(resItem)
      }
      return resList
    },
    scrollToTop () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      console.log('scrollTop:', scrollTop)
      console.log('top:', window.scrollTop)
      let browserHeight = window.outerHeight
      // if (scrollTop > browserHeight) {
      //   this.showScrollTopBtn = true
      // } else {
      //   this.showScrollTopBtn = false
      // }
    },
    scrollTopBtnClick () {
      this.$refs.mainDiv.scrollIntoView()
    },
    getTestData () {
      let name = this.curTree.fileInfo.name
      for (let i = 0; i < 20; i++) {
        let tmpName = '文件夹' + Math.random().toString(36).substr(2, 4).toUpperCase()
        let itemTree = {fileInfo: {id: tmpName, name: tmpName, fileType: 0, updateTime: '2019-11-20 22:00'}, parent: this.curTree, children: []}
        this.curTree.children.push(itemTree)
      }
    },
    createUploader (type) {
      let self = this
      let uploader = new AliyunUpload.Vod({
        timeout: 60000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: 'cn-shanghai',
        userId: '123456',
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false
          self.resumeDisabled = false
          self.statusText = '添加文件成功, 等待上传...'
          console.log("addFileSuccess: " + uploadInfo.file.name)
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          let requestData = {name: uploadInfo.file.name}
          self.$api.cloudDisk.getAliCloudUploadToken(requestData).then((res) => {
            if(res.code === 0){
              console.log(res)
              uploader.setUploadAuthAndAddress(uploadInfo, res.data.token, res.data.addr, res.data.videoid)
            }
          })

        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {

          let videoId = uploadInfo.videoId
          let userData = JSON.parse(Base64.decode(uploadInfo.userData))
          let md5 = userData.md5
          let fileName = uploadInfo.file.name
          self.uploadCloudMediaFileSuccess(videoId,fileName,md5)
          console.log('onUploadSucceed' + uploadInfo)
          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
        },

        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log("onUploadEnd: uploaded all the files")
        }
      })
      return uploader
    }
  }
}
</script>

<style scoped>
  .title-container{
    margin: 30px;
  }
  .file-list{
    margin: 30px;
  }
  .el-dialog{
    display: flex;
    flex-direction: column;
    margin:0 !important;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    /*height:600px;*/
    max-height:calc(100% - 30px);
    max-width:calc(100% - 30px);
  }
  .el-dialog .el-dialog__body{
    flex:1;
    overflow: auto;
  }
  .tea-cloud-disk-btn{
    background-color: #82BCB8;
    border-color: #82BCB8;
  }
</style>



// WEBPACK FOOTER //
// src/page/cloudDisk/CloudDisk.vue